export default __webpack_public_path__ + "static/media/LanceroOpen.fa0e1a64.jpg";